import { DEFAULT_VOUCHER_SLICE_SIZE } from "commons/constants";
import {
  IAddQuotation,
  IQuotationProperties,
  IUpdateQuotation,
} from "mobx-stores/_models/quotation/quotation";
import { BaseBussiness } from "../base";

class QuotationBusiness extends BaseBussiness<
  IQuotationProperties,
  IAddQuotation,
  IUpdateQuotation,
  IQuotationProperties
> {
  url = "";
  constructor(url: string) {
    super(url);
    this.url = url;
  }

  public searchQuotations = async (keyword: string) => {
    const res = await this.getLists({
      filter: keyword,
      maxResultCount: DEFAULT_VOUCHER_SLICE_SIZE,
      skipCount: 0,
      sorting: "",
    });

    return res;
  };
}

export const quotationBusiness = new QuotationBusiness("/api/app/quotation");
